export default __webpack_public_path__ + "static/main-meta-fcce75c2cbc32a18c853ff657f643e6a.jpg";